import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";
import { firstValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { GeocodingModel, HEREGeocodingParams } from "src/app/models/location.model.js";
import { OrderModel } from "src/app/models/order.model";
import { TourneeModel } from "src/app/models/tournee.model";
import { hereMapsConfig, locationIDConfig } from "src/environments/environment";
/*
  Generated class for the DataServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
declare var H: any;

@Injectable({ providedIn: "root" })
export class ExternalService {
  constructor(private platform: Platform, private http: HttpClient) {}

  init() {}

  getPlace(name: string, location: string): string {
    const url = "https://www.google.com/maps/search/?api=1&query=" + name + "+" + location;
    return encodeURI(url);
  }

  calculateBestRoute(addresses: any[]) {
    const APIURL = "https://api.routexl.com/";
    const latLong = firstValueFrom(this.http
      .post(APIURL, addresses)
      .pipe(map(response => this.transformRouteXL(response))));
    return latLong;
  }

  showRoute(to: string, from?: string): string {
    let url = "";
    switch (this.platform.platforms[2]) {
      case "ios":
        url = "http://maps.apple.com/?";
        url += from == undefined ? "saddr=" + from : "";
        url += "&daddr=" + to + "&dirflg=d";
        break;

      case "android":
      default:
        url = "https://www.google.com/maps/dir/?api=1";
        url += from != undefined ? "&origin=" + from : "";
        url += "&destination=" + to + "&travelmode=driving";
        break;
    }
    return encodeURI(url);
  }

  showAddress(address: string): string {
    let url = "";
    switch (this.platform.platforms[2]) {
      case "ios":
        url = "http://maps.apple.com/?q=" + address
        break;

      case "android":
      default:
        url = "https://www.google.com/maps/search/?api=1&query=" + address;
        break;
    }
    return encodeURI(url);
  }

  openExternalMap(item:any){
    window.open(this.showAddress(item.details?.geocoding?.label || item.geocoding?.label || item.details?.dates[0]?.geocoding?.label), "_blank");
  }

  geocodeLocation(
    location: string,
    country?: string,
    city?: string,
    postalCode?: string,
    street?: string,
    houseNumber?: string,
    source?: string
  ): Promise<GeocodingModel[]> {
    if (source == "locationIQ") {
      return this.geocodeLocationWithLocationIQ(location, country, city, postalCode, street, houseNumber);
    } else {
      return this.geocodeLocationWithHere(location, country, city, postalCode, street, houseNumber);
    }
  }

  geocodeLocationWithLocationIQ(location, country?: string, city?: string, postalCode?: string, street?: string, houseNumber?: string) {
    let APIURL = "https://eu1.locationiq.com/v1/search.php?key=" + locationIDConfig.apiKey;

    APIURL += location !== null ? "&q=" + location : "";
    APIURL += country !== null ? "&country=" + country : "";
    APIURL += city !== null ? "&city=" + city : "";
    APIURL += postalCode !== null ? "&postalCode=" + postalCode : "";
    APIURL += street !== null ? "&street=" + street : "";
    APIURL += "&format=json";
    console.log(APIURL);
    const latLong = firstValueFrom(this.http
      .get(APIURL)
      .pipe(map(response => this.transformLocationIQResponse(response))))
    return latLong;
  }

  geocodeLocationWithHere(
    location: string,
    countryCode?: string,
    city?: string,
    postalCode?: string,
    street?: string,
    houseNumber?: string
  ): Promise<GeocodingModel[]> {
    const geocodingParams: HEREGeocodingParams = {};
    if (location !== null) {
      geocodingParams.q = location;
      if (countryCode) {
        geocodingParams.in = "countryCode:" + countryCode;
      }
    } else {
      let query = "";
      query += countryCode !== null && countryCode !== undefined ? ";country=" + countryCode : "";
      query += city !== null && city !== undefined ? ";city=" + city : "";
      query += postalCode !== null && postalCode !== undefined ? ";postalCode=" + postalCode : "";
      query += street !== null && street !== undefined ? ";street=" + street : "";
      query += houseNumber !== null && houseNumber !== "0" && houseNumber !== undefined ? ";houseNumber=" + houseNumber : "";
      query = query.slice(1);
      geocodingParams.qq = query;
    }
    const apiKey = hereMapsConfig.apiKey;
    const platform = new H.service.Platform({
      apikey: apiKey
    });
    // console.log(geocodingParams);
    const geocoder = platform.getSearchService();
    return new Promise((resolve, reject) => {
      geocoder.geocode(
        geocodingParams,
        result => {
          // console.log(result);
          if (result.items.length > 0) {
            resolve(result.items.map(this.transformHereResponse));
          } else {
            reject({ message: "no results found", code: 204 });
          }
        },
        error => {
          reject(error);
        }
      );
    });
  }

  autoCompleteWithHere(
    query: string
  ): Promise<GeocodingModel[]> {
    const geocodingParams: HEREGeocodingParams = {};
    geocodingParams.q = query;
    const apiKey = hereMapsConfig.apiKey;
    const platform = new H.service.Platform({
      apikey: apiKey
    });
    console.log(geocodingParams);
    const geocoder = platform.getSearchService();
    return new Promise((resolve, reject) => {
      geocoder.autocomplete(
        geocodingParams,
        result => {
          console.log(result);
          if (result.items.length > 0) {
            resolve(result.items.map(this.transformHereResponse));
          } else {
            reject({ message: "no results found", code: 204 });
          }
        },
        error => {
          reject(error);
        }
      );
    });
  }

  transformLocationIQResponse(response: any) {
    console.log(response[0]);
    const responseFormated = response[0];
    return responseFormated;
  }

  transformOpenStreetMapResponse(response: any) {
    const responseFormated = response[0];
    const lat = parseFloat(responseFormated["lat"]).toFixed(5);
    const long = parseFloat(responseFormated["lon"]).toFixed(5);
    const url: string = "https://map.openseamap.org/?zoom=18&lat=" + lat + "&lon=" + long + "&layers=BFTFFFFFFTF0FFFFFFFFFF";
    return url;
  }

  transformRouteXL(response: any) {
    console.log(response);
    return response;
  }

  transformHereResponse(response: any): GeocodingModel {
    // console.log(response);
    const location: GeocodingModel = {
      label: response.address.label,
      source: "Here",
      relevance: response.scoring.queryScore || null,
      locationType: response.localityType || null,
      resultType: response.resultType,
      locationID: response.id,
      latitude: response.position.lat,
      longitude: response.position.lng,
      address: {
        name: response.resultType == 'place' && response.title?response.title:null,
        country: response.address.countryName || null,
        countryCode: response.address.countryCode || null,
        state: response.address.state || null,
        county: response.address.county || null,
        city: response.address.city || null,
        postalCode: response.address.postalCode || null,
        street: response.address.street || null,
        houseNumber: response.address.houseNumber || null
      }
    };
    return location;
  }

  async calculateRoute(tournee: TourneeModel) {
    const addresses = [];
    const startEnd = {
      name: tournee.producer.details.shortDetails.name,
      address: tournee.producer.details.geocoding.label,
      lat: tournee.producer.details.geocoding.latitude,
      lng: tournee.producer.details.geocoding.longitude
    };
    addresses.push(startEnd);
    for (const [key, value] of Object.entries(tournee.orders)) {
      const order: OrderModel = value;
      let address = {
        name: order.consumer.details.fullDetails.firstname + order.consumer.details.fullDetails.lastname,
        address: order.consumer.details.geocoding.label,
        lat: order.consumer.details.geocoding.latitude,
        lng: order.consumer.details.geocoding.longitude,
        servicetime: 5
      };
      addresses.push(address);
    }
    addresses.push(startEnd);
    const routeCalculated = await this.calculateBestRoute(addresses);
    let routeSorted = [];
    for (const [keyCalculated, valueCalculated] of Object.entries(routeCalculated)) {
      for (const [key, value] of Object.entries(tournee.orders)) {
        if (value["details"]["address"]["geocoding"]["label"] == valueCalculated["name"]) {
          let order: OrderModel = { key: key, ...value as {}};
          let routeStep = {
            order: order,
            step: keyCalculated,
            arrival: valueCalculated["arrival"],
            distance: valueCalculated["distance"]
          };
          valueCalculated["order"] = order;
          routeSorted.push(routeStep);
        }
      }
    }
    const route: any = {
      totalDistanceKm: 0,
      steps: routeSorted
    };
    console.log(route, routeSorted, routeCalculated);
    //this.dataService.updateTourneeRoute(tournee,route);
    return tournee.route;
  }
}
